import {combineReducers} from '@reduxjs/toolkit';
import authReducer from 'slices/auth/auth.slice';
import menuReducer from 'slices/security/menu.slice';
import inquiryEkycReducer from 'slices/inquiry/inquiry.ekyc.slice';
import myTaskEkycReducer from 'slices/myTask/mytask.ekyc.slice';
import myTaskMaintenanceReducer from 'slices/myTask/mytask.maintenance.slice';
import reportReducer from 'slices/report/report.slice';
import auditTrailReducer from 'slices/report/auditTrail.slice';
import sysConfigReducer from 'slices/maintenance/sysConfiguration.slice';
import roleReducer from 'slices/security/role.slice';
import userReducer from 'slices/security/user.slice';
import droplistReducer from 'slices/droplist.slice';

const rootReducer = combineReducers({
  auth: authReducer,
  menu: menuReducer,
  droplist: droplistReducer,

  // inquiry
  inquiry: inquiryEkycReducer,

  // myTask
  apprv_ekyc: myTaskEkycReducer,
  apprv_maintenance: myTaskMaintenanceReducer,

  // report
  audit_trail: auditTrailReducer,
  report: reportReducer,

  // maintenance
  sysConfig: sysConfigReducer,

  // security
  role: roleReducer,
  user: userReducer,
});

export default rootReducer;